import { CmsObjectWithDefault } from '@components/Cms/types';

export type SocialButtonsCmsKey =
    | 'SignInWithApple'
    | 'SignInWithFacebook'
    | 'SignInWithWechat'
    | 'SignInWithGoogle'
    | 'SignInWithMobile'
    | 'SignInWithKakao'
    | 'SignInWithLine'
    | 'SignInWithWhatsApp';

export const SocialButtonsCmsWithDefault: CmsObjectWithDefault<SocialButtonsCmsKey> = {
    SignInWithApple: {
        cmsId: 233019,
        defaultTranslation: 'Sign in with Apple',
    },
    SignInWithFacebook: {
        cmsId: 206174,
        defaultTranslation: 'Sign in with Facebook',
    },
    SignInWithGoogle: {
        cmsId: 173870,
        defaultTranslation: 'Sign in with Google',
    },
    SignInWithMobile: {
        cmsId: 331888,
        defaultTranslation: 'Sign in with Mobile',
    },
    SignInWithWechat: {
        cmsId: 109058,
        defaultTranslation: 'Sign in with Wechat',
    },
    SignInWithKakao: {
        cmsId: 337740,
        defaultTranslation: 'Sign in with Kakao',
    },
    SignInWithLine: {
        cmsId: 349749,
        defaultTranslation: 'Sign in with Line',
    },
    SignInWithWhatsApp: {
        cmsId: 331891,
        defaultTranslation: 'Sign in with WhatsApp',
    },
};
